import React from "react";
import { ConfigFormView } from "../../../../common/ConfigForm/ConfigFormView";
import { NE1_SECTIONS } from "../ne1.config";
import { EDIT } from "../../../../../constants";
import formStyle from "../../../../common/ConfigForm/ConfigForm.module.scss";
import styles from "../Ne1.module.scss";

export const Ne1ViewMode = ({ customerData, onEdit }) => (
  <div className={formStyle.form_container}>
    <div className={`${styles.status_bar} ${styles.status_bar_view}`}>
      <div className={styles.status_group}>
        <h2 className={styles.status_title}>NE1 - Paid:</h2>
        <span className={styles.status_value}>{customerData?.settings?.ne1Wms === 1 ? "Enable" : "Disable"}</span>
      </div>
      <button type="button" className={formStyle.form_edit_btn} onClick={onEdit}>
        <i className="fa fa-pencil" aria-hidden="true"></i>
        {EDIT}
      </button>
    </div>

    <div className={styles.columns}>
      <div className={styles.column}>
        <ConfigFormView sections={NE1_SECTIONS} column="left" data={customerData?.settings} />
      </div>
      <div className={styles.column}>
        <ConfigFormView sections={NE1_SECTIONS} column="right" data={customerData?.settings} />
      </div>
    </div>
  </div>
);
